// extracted by mini-css-extract-plugin
module.exports = {"TooltipWrapper":"CustomTooltip_TooltipWrapper__kKjpC","TooltipText":"CustomTooltip_TooltipText__3M55I","TooltipTextAngle":"CustomTooltip_TooltipTextAngle__J-Uq5"};